import React, {Component} from 'react';

class Warnings extends Component {

    render() {

        const allergies = this.props.prescriptionHistory.warnings.map(warning => (
            <li key={warning}>{warning}</li>
        ));
        return (
            <ul>
                {allergies}
            </ul>
        );
    }
}

export default Warnings;
